module.exports = __webpack_public_path__ + "static/media/1023464.08dd6536.png";